/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeModel } from '../../models/employee-model';

export interface GetAttorneys$Plain$Params {
}

export function getAttorneys$Plain(http: HttpClient, rootUrl: string, params?: GetAttorneys$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
  const rb = new RequestBuilder(rootUrl, getAttorneys$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeModel>>;
    })
  );
}

getAttorneys$Plain.PATH = '/api/Attorney';
